import React, { useState } from 'react';
import { BookOpenIcon, ShieldCheckIcon, AwardIcon } from 'lucide-react';
const TrustStrip: React.FC = () => {
  const [showSources, setShowSources] = useState(false);
  return <section className="w-full py-8 bg-[#0A1020] border-t border-b border-gray-800" data-id="element-363">
      <div className="max-w-5xl mx-auto px-4" data-id="element-364">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-sm text-gray-300" data-id="element-365">
          <div className="flex items-center gap-2" data-id="element-366">
            <BookOpenIcon className="w-5 h-5 text-[#0EB7FF]" data-id="element-367" />
            <span data-id="element-368">Baserat på klinisk forskning</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-369">
            <ShieldCheckIcon className="w-5 h-5 text-[#0EB7FF]" data-id="element-370" />
            <span data-id="element-371">Fokus på naturliga lösningar</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-372">
            <AwardIcon className="w-5 h-5 text-[#0EB7FF]" data-id="element-373" />
            <span data-id="element-374">Rekommenderad av experter</span>
          </div>
          <button onClick={() => setShowSources(!showSources)} className="text-[#0EB7FF] hover:underline text-sm font-medium" data-id="element-375">
            {showSources ? 'Dölj källor' : 'Läs mer'}
          </button>
        </div>
        {showSources && <div className="mt-4 p-4 bg-gray-900 rounded-md text-sm text-gray-300" data-id="element-376">
            <h3 className="font-semibold mb-2" data-id="element-377">
              Manlig sexuell hälsa påverkas av fyra huvudfaktorer:
            </h3>
            <ul className="space-y-2 text-xs" data-id="element-378">
              <li data-id="element-379">• Blodcirkulation: Avgörande för kvaliteten på erektioner</li>
              <li data-id="element-380">
                • Hormonbalans: Testosteronnivåer påverkar sexdrift och
                prestationsförmåga
              </li>
              <li data-id="element-381">
                • Cellhälsa: Antioxidanter skyddar vävnad och främjar
                regenerering
              </li>
              <li data-id="element-382">
                • Energi och kondition: Direkt koppling till uthållighet och
                prestation
              </li>
            </ul>
          </div>}
      </div>
    </section>;
};
export default TrustStrip;